<div
  class="soft-container soft-container-column"
  *ngIf="form && definition"
>
  <label class="soft-label soft-label-top"
    >{{ definition.title }}
    <span
      class="required-indicator"
      *ngIf="definition.required | booleanRule: form.value"
      >*</span
    >
  </label>
  <ng-container [ngSwitch]="definition.control">
    <soft-date-time-input
      *ngSwitchCase="'datetime'"
      [formControl]="form|formControl:definition.name"
      softFieldValidation
    ></soft-date-time-input>
    <soft-time-input
      *ngSwitchCase="'time'"
      [formControl]="form|formControl:definition.name"
      [format]="definition.format | formatRule: form.value"
      softFieldValidation
    ></soft-time-input>
    <soft-date-input
      *ngSwitchDefault
      [formControl]="form|formControl:definition.name"
      [format]="definition.format | formatRule: form.value"
      softFieldValidation
    ></soft-date-input>
  </ng-container>
</div>
